import React, { createContext, useContext } from 'react';
import { useTargetListAdd } from '../../hooks';

const TargetListAddContext = createContext();

export const TargetListAddProvider = ({ children }) => {
  const {
    targetList,
    setTargetList,
    defaultList,
    setDefaultList,
    listName,
  } = useTargetListAdd();

  return (
    <TargetListAddContext.Provider
      value={{
        targetList,
        setTargetList,
        defaultList,
        setDefaultList,
        listName,
      }}
    >
      {children}
    </TargetListAddContext.Provider>
  );
};

export const useTargetListAddContext = () => useContext(TargetListAddContext);
